import VjsPlayer from "./VjsPlayer";

export default VjsPlayer;
